import React, { PureComponent } from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

import ProgressIndicator from 'eventbrite_design_system/progressIndicator/ProgressIndicator';
import {
    addWindowListener,
    removeWindowListener,
} from 'eventbrite_design_system/utils/dom';

import EventsConflictsTableHeader from './EventsConflictsTableHeader';
import EventConflictsTableFooter from './EventsConflictsTableFooter';
import EventsConflictsTableBody from './EventsConflictsTableBody';
import { getPaginatorSize } from '../utils';
import { CONFLICTS_PROP_TYPES } from '../../constants/downgrade';

const EventsConflictPageLoading = ({ isLoading }) =>
    isLoading ? (
        <div data-spec="events-screen-loading">
            <ProgressIndicator shape="linear" style="gradient" />
        </div>
    ) : null;

const EventsConflictsTable = ({
    isLoading,
    paginationSize,
    conflicts,
    pagination,
    onPageChange,
}) =>
    !isLoading ? (
        <div>
            <EventsConflictsTableHeader />
            <EventsConflictsTableBody conflicts={conflicts} />
            <EventConflictsTableFooter
                paginationSize={paginationSize}
                onPageChange={onPageChange}
                {...pagination}
            />
        </div>
    ) : null;

export default class EventsConflicts extends PureComponent {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func.isRequired,
        conflicts: CONFLICTS_PROP_TYPES,
    };

    constructor(props) {
        super(props);
        this.state = {
            paginationBarSize: getPaginatorSize(),
        };
    }

    componentDidMount() {
        addWindowListener(
            'resize',
            debounce(this.updatePaginationBarSize, 100),
        );
    }

    componentWillUnmount() {
        removeWindowListener('resize', this.updatePaginationBarSize);
    }

    updatePaginationBarSize = () => {
        this.setState({ paginationBarSize: getPaginatorSize() });
    };

    render() {
        const {
            isLoading,
            conflicts: { pagination, conflicts },
            onPageChange,
        } = this.props;
        const { paginationBarSize } = this.state;

        return (
            <section className="eds-g-cell eds-g-cell-1-1 eds-l-pad-top-10">
                <EventsConflictPageLoading isLoading={isLoading} />
                <EventsConflictsTable
                    isLoading={isLoading}
                    paginationSize={paginationBarSize}
                    pagination={pagination}
                    conflicts={conflicts}
                    onPageChange={onPageChange}
                />
            </section>
        );
    }
}
